import { Autocomplete, DisplayModes } from '@coconut-software/ui';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { CountryContext } from '../contexts/CountryContext';
import { TimezonesContext } from '../contexts/TimezonesContext';
import TimezoneLabel from './TimezoneLabel';

const DesktopTimezonePicker = ({ setTimezone, timezone }) => {
  const intl = useIntl();
  const timezones = useContext(TimezonesContext);
  const [country] = useContext(CountryContext);

  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const inputRef = useRef(null);
  const displayRef = useRef(null);

  const options = useMemo(() => {
    setLoading(false);

    return search
      ? Object.values(timezones).filter((tz) =>
          tz.name.toLowerCase().includes(search.toLowerCase()),
        )
      : Object.values(timezones);
  }, [search, timezones]);

  useEffect(() => {
    if (!timezones[timezone.id] && inputRef.current && displayRef.current) {
      inputRef.current.value = '';
      displayRef.current.value = '';

      setTimezone({});
    }
  }, [setTimezone, timezone.id, timezones]);

  const selectTimezone = (event) => {
    if (event?.currentTarget?.value === timezone?.id) {
      return;
    }

    setTimezone({
      id: event?.currentTarget?.value,
      name: event?.currentTarget?.value,
      country: country,
    });
  };

  const handleSearchInput = (event) => {
    setLoading(true);
    setSearch(event.target.value);
  };

  return (
    <Autocomplete
      defaultValue={timezone.id}
      displayRef={displayRef}
      inputRef={inputRef}
      label={intl.formatMessage({
        id: 'CountryTimezoneModal.timezone_label',
      })}
      loading={loading}
      name="timezone"
      onChange={(event) => handleSearchInput(event)}
      onSelect={selectTimezone}
      select
    >
      <Autocomplete.Group display={DisplayModes.Always} key="all">
        {options.map((tz) => (
          <Autocomplete.Suggestion key={tz.id} value={tz.id}>
            <TimezoneLabel fallback={tz.id} timezone={tz} withName />
          </Autocomplete.Suggestion>
        ))}
      </Autocomplete.Group>
    </Autocomplete>
  );
};

DesktopTimezonePicker.propTypes = {
  setTimezone: PropTypes.func.isRequired,
  timezone: PropTypes.shape(),
};

export default DesktopTimezonePicker;
